import { priorityLabels, sourceLabels, statusLabels } from '../../domain/taskRules'
import type { CatalogRecord, TaskFilters as Filters } from '../../types/domain'

type Props = {
  value: Filters
  clients: CatalogRecord[]
  assignees: CatalogRecord[]
  departments: CatalogRecord[]
  onChange: (filters: Filters) => void
}

export function TaskFilters({ value, clients, assignees, departments, onChange }: Props) {
  const update = <K extends keyof Filters>(key: K, next: Filters[K]) =>
    onChange({ ...value, [key]: next })

  return (
    <section className="card p-4" aria-label="Filtros de tarefas">
      <div className="mb-3 flex items-center justify-between gap-3">
        <h2 className="font-extrabold text-slate-800">Filtros</h2>
        <button
          className="text-sm font-bold text-blue-700 hover:underline"
          type="button"
          onClick={() => onChange({ clientId: '', assigneeId: '', departmentId: '', priority: '', source: '', status: '', archived: value.archived, todayOnly: value.todayOnly })}
        >
          Limpar
        </button>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-6">
        <label className="field"><span>Cliente</span><select className="control" value={value.clientId} onChange={(event) => update('clientId', event.target.value)}><option value="">Todos</option>{clients.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}</select></label>
        <label className="field"><span>Responsável</span><select className="control" value={value.assigneeId} onChange={(event) => update('assigneeId', event.target.value)}><option value="">Todos</option>{assignees.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}</select></label>
        <label className="field"><span>Departamento</span><select className="control" value={value.departmentId} onChange={(event) => update('departmentId', event.target.value)}><option value="">Todos</option>{departments.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}</select></label>
        <label className="field"><span>Prioridade</span><select className="control" value={value.priority} onChange={(event) => update('priority', event.target.value as Filters['priority'])}><option value="">Todas</option>{Object.entries(priorityLabels).map(([item, label]) => <option key={item} value={item}>{label}</option>)}</select></label>
        <label className="field"><span>Origem</span><select className="control" value={value.source} onChange={(event) => update('source', event.target.value as Filters['source'])}><option value="">Todas</option>{Object.entries(sourceLabels).map(([item, label]) => <option key={item} value={item}>{label}</option>)}</select></label>
        <label className="field"><span>Status</span><select className="control" value={value.status} onChange={(event) => update('status', event.target.value as Filters['status'])}><option value="">Todos</option>{Object.entries(statusLabels).map(([item, label]) => <option key={item} value={item}>{label}</option>)}</select></label>
      </div>
    </section>
  )
}
